/**
 * useGetPotPeriods
 * React Query hook for fetching pot periods
 * Fetches periods for a year range (default: 3 years from current year)
 * Empty periods are filtered out by default unless includeEmpty is true
 */

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useAuthStore } from '../../auth/stores/authStore';
import {
  getPotPeriods,
  GetPotPeriodsResponse,
  GetPotPeriodsOptions,
} from '../api/potPeriodsApi';
import { potPeriodKeys } from './potPeriodKeys';

export function useGetPotPeriods(
  options?: GetPotPeriodsOptions,
  queryOptions?: Partial<UseQueryOptions<GetPotPeriodsResponse, Error>>
) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    // Include yearsToLoad in cache key so different ranges are cached separately
    queryKey: potPeriodKeys.list(options),
    queryFn: async () => {
      return await getPotPeriods(options);
    },
    enabled: isAuthenticated,
    staleTime: 30 * 1000, // Cache for 30 seconds (periods don't change frequently)
    ...queryOptions,
  });
}
